// extracted by mini-css-extract-plugin
export default {"light":"bJw1PiuHwPTc6_IzqJId"};